import React, { FC, PropsWithChildren } from 'react';
import classnames from 'classnames';

import styles from './_Note.module.css';

interface NoteProps {
    lines?: 1 | 2 | 3 | 4 | 5;
}

export const Note: FC<PropsWithChildren<NoteProps>> = ({ children, lines = 5 }) => (
    <span className={classnames(styles.note, styles.clamp, styles[`clamp_lines_${lines}`])}>
        {children}
    </span>
);
